export const convertNumberDecimal = (value: number) => {
  if (Number.isInteger(value)) {
    return value;
  }

  const partes = value.toString().split(".");

  if (partes[1].length > 2) {
    return parseFloat(value.toFixed(2));
  }

  return value;
};
